import { render, staticRenderFns } from "./editBusiness.vue?vue&type=template&id=2abe41b3&scoped=true&"
import script from "./editBusiness.vue?vue&type=script&lang=js&"
export * from "./editBusiness.vue?vue&type=script&lang=js&"
import style0 from "./editBusiness.vue?vue&type=style&index=0&id=2abe41b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe41b3",
  null
  
)

export default component.exports